import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, EMPTY, throwError, of } from 'rxjs';
import { tap, catchError, share } from 'rxjs/operators';

@Injectable()
export class NotFoundInterceptor implements HttpInterceptor {
    constructor(private router: Router) { }
    private cache: Map<string, HttpResponse<any>> = new Map()

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


        if (request.headers.get("svg")) {
            const cachedResponse: HttpResponse<any> = this.cache.get(request.url)
            if (cachedResponse) {
                return of(cachedResponse.clone())
            } else {
                return next.handle(request).pipe(
                    tap(stateEvent => {

                        if (stateEvent instanceof HttpResponse) {
                            this.cache.set(request.url, stateEvent.clone())
                        }
                    }), share())
            }
        }

        return next.handle(request).pipe(
            catchError((err: any) => {
                if (err instanceof HttpErrorResponse && err.status == 404) {
                    this.router.navigate(['/not-found']);
                }
                return throwError(err);
            }));
    }
}